module.exports = __webpack_public_path__ + "img/happy.f0580fef.svg";